import '../app.ts'
import '/@front:css/views/properties.index.css'
import '@splidejs/vue-splide/css/core'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import { computed, onMounted, ref } from 'vue'

import { showUpgradeModal } from '/@front:shared/composables/modal'
import { searchUnitGroup } from '/@front:shared/constants'
import { mountPage } from '/@front:shared/mount-page'

const singleCapacityGroups = [searchUnitGroup.ROOM, searchUnitGroup.PARKING, searchUnitGroup.COMMERCIAL]
const fixedHeight = Math.max(220, Math.min(400, Math.ceil(window.innerWidth / 2)))

mountPage({
  name: 'properties.index',
  components: {
    Splide,
    SplideSlide,
  },
  data() {
    return {
      splideOptions: {
        type: window.innerWidth < 800 ? 'loop' : 'slide',
        width: '100dvw',
        fixedHeight: `${fixedHeight}px`,
        gap: '10px',
        autoWidth: true,
        pagination: false,
      },
    }
  },
  setup() {
    const unitGroup = ref('room')
    const rentMax = ref(-1)
    const surfaceMin = ref(0)
    const capacity = ref('one')
    const sort = ref('-rent')
    const searchForm = ref<HTMLFormElement | null>(null)

    const isCapacityFilterRelevant = computed(() => {
      // @ts-expect-error: argument doesn't match
      return !singleCapacityGroups.includes(unitGroup.value)
    })

    const isPremium = window._state.subscriber?.isPremium ?? false

    // Applying a filter reloads the page; hand focus back to the filter afterwards.
    const focusedFilterKey = 'properties:focused-filter'

    const updateFilters = (event: Event) => {
      try {
        sessionStorage.setItem(focusedFilterKey, (event.target as HTMLSelectElement).name)
      } catch (_e) {
        // ignore
      }

      searchForm.value?.submit()
    }

    const restoreFilterFocus = () => {
      try {
        const name = sessionStorage.getItem(focusedFilterKey)
        sessionStorage.removeItem(focusedFilterKey)

        if (name) {
          document.querySelector<HTMLSelectElement>(`.filters select[name="${name}"]`)?.focus()
        }
      } catch (_e) {
        // ignore
      }
    }

    onMounted(() => {
      const windowState = window._state
      unitGroup.value = windowState.search.group
      surfaceMin.value = windowState.search.surfaceMin
      rentMax.value = windowState.search.rentMax
      capacity.value = windowState.search.capacity
      sort.value = windowState.search.sort || '-rent'

      restoreFilterFocus()
    })

    return {
      unitGroup,
      rentMax,
      surfaceMin,
      capacity,
      sort,
      isCapacityFilterRelevant,
      isPremium,
      showUpgradeModal,
      updateFilters,
      searchForm,
    }
  },
})
